import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormField } from '../../../shared/models/form-builder/form-field.model';

@Component({
    selector: 'app-reorder-grid-columns',
    templateUrl: './reorder-grid-columns.dialog.html',
    styleUrls: ['./reorder-grid-columns.dialog.scss'],
    standalone: false
})
export class ReorderGridColumnsDialog implements OnInit {

    private columnDefs: FormField[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) data,
        public dialogRef: MatDialogRef<ReorderGridColumnsDialog>) {

        for (let col of data.columns) {
            let field = new FormField();
            field.name = col.displayName || col.name;
            field.id = col.id;
            this.columnDefs.push(field);
        }
    }

    ngOnInit(): void {
    }

    public get ColumnDefs() {
        return this.columnDefs;
    }

    public handleRowReorder(event: any) {

        let dataItem = event.dropTargetRow.dataItem;
        let originalIndexOfMovedRow = event.draggedRows[0].rowIndex;
        let originalIndexOfTargetRow = event.dropTargetRow.rowIndex;

        let dropPosition = event.dropPosition;
        let newIndex = dropPosition == 'before' ? originalIndexOfTargetRow : (originalIndexOfTargetRow + 1);

        let movedRow = this.columnDefs.splice(originalIndexOfMovedRow, 1)[0]; // first remove the moved Row but keep a reference to it so it can be reinserted
        let before = this.columnDefs.slice(0, newIndex); // grab everything before its new location in the array
        let after = this.columnDefs.slice(newIndex); // grab everything after its new location in the array

        this.columnDefs = [
            ...before,
            movedRow,
            ...after
        ];
    }

    public closeDialog(save: boolean = false) {
        if (save) {
            // TODO: make sure to check if there is data out there using this -- need to prevent re-ordering if so
            this.dialogRef.close(this.columnDefs);
        } else {
            this.dialogRef.close();
        }
    }
}
